import { useLiveQuery } from 'dexie-react-hooks';

import { DEXIE_IS_LOADING } from '../lib/db';

// useLiveQuery retains the previous dependency set's result while a re-keyed query
// resubscribes, so the first render after a key change can serve another key's rows as
// if they were this key's. Tagging each emission with the key it answered makes that
// window detectable instead of a landmine.
export function isCurrentKeyedResult(result, queryKey) {
  return result !== DEXIE_IS_LOADING && result?.key === queryKey;
}

// A live query whose result can never masquerade as another key's data: `loaded` is
// true only once the current key's own emission is in, and `value` is null until then
// (and null for a missing row — Dexie's undefined is normalized away).
//
// `key` must encode every input `querier` reads — it is also the only dependency, so
// two different queries must never share a key. A null key short-circuits to a loaded
// null without running `querier`.
export default function useKeyedLiveQuery(key, querier) {
  const result = useLiveQuery(async () => ({ key, value: key == null ? null : await querier() }), [key], DEXIE_IS_LOADING);
  const loaded = isCurrentKeyedResult(result, key);

  return { loaded, value: loaded ? (result.value ?? null) : null };
}
